import React, { FC, useEffect } from 'react';
import { FieldModel } from '../../../../../../models/form/field';
import { useState } from 'react';

export interface Props {
  field: FieldModel;
  dragItem: FieldModel | undefined;
  setDragItem: (field: FieldModel | undefined) => void;
  swapedItemId: string | undefined;
  setSwapedItemId: (field: string | undefined) => void;
  swap: (id: string) => void;
  children: React.ReactNode;
  updateRights?: boolean;
}

const Draggable: FC<Props> = ({
  children,
  field,
  setDragItem,
  swap,
  dragItem,
  setSwapedItemId,
  swapedItemId,
  updateRights,
}: Props) => {
  const [isDraggable, setIsDraggable] = useState(false);

  useEffect(() => {
    if (!updateRights) {
      setIsDraggable(false);
    }
  }, [updateRights]);
  const onDragEnd = () => {
    setDragItem(undefined);
    setIsDraggable(false);
  };
  const onDragEnter = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.dataTransfer.effectAllowed = 'move';

    if (swapedItemId !== field.id && dragItem && dragItem.id !== field.id) {
      swap(field.id);
      setSwapedItemId(field.id);
    } else if (swapedItemId !== field.id) {
      setSwapedItemId(undefined);
    }
  };
  const onDragStart = (e) => {
    e.dataTransfer.effectAllowed = 'move';
    setSwapedItemId(undefined);
    setDragItem(field);
  };
  const onDrop = (e) => {
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    if (e.preventDefault) {
      e.preventDefault();
    }
    setDragItem(undefined);
    setIsDraggable(false);
  };
  const onDragOver = (e) => {
    e.dataTransfer.dropEffect = 'move';
  };
  const onDrag = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.dataTransfer.dropEffect = 'move';
  };
  return (
    <div
      className="draggable"
      key={field.id}
      draggable={isDraggable && updateRights}
      id={field.id}
      onDrag={onDrag}
      onDragEnd={onDragEnd}
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDragStart={onDragStart}
      onDrop={onDrop}
    >
      {updateRights && (
        <span
          onMouseDown={() => setIsDraggable(true)}
          style={{ cursor: 'move' }}
          className="mdi mdi-drag-vertical"
        ></span>
      )}
      {children}
    </div>
  );
};

export default Draggable;
